import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import Teams from './Teams';
import UsersList from './UsersList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TabIds = {
  teams: 'teams',
  users: 'users'
};
const AssignmentPanelTabs = ({
  ownerId,
  teams,
  selectedTeams,
  selectedUsers,
  usersForTeams,
  userSearch,
  selectedTab,
  handleTeamChange,
  handleTabChange,
  handleUserChange,
  handleUserSearch,
  canAssignContent
}) => /*#__PURE__*/_jsxs(Tabs, {
  selected: selectedTab,
  onSelectedChange: event => handleTabChange(event.target.value),
  marginBlockStart: "400",
  children: [/*#__PURE__*/_jsx(Tab, {
    tabId: TabIds.teams,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentPartitioning.assignmentPanel.tabs.teams"
    }),
    children: /*#__PURE__*/_jsx(Teams, {
      teams: teams,
      selectedTeams: selectedTeams,
      handleTeamChange: handleTeamChange,
      canAssignContent: canAssignContent
    })
  }), /*#__PURE__*/_jsx(Tab, {
    tabId: TabIds.users,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentPartitioning.assignmentPanel.tabs.users"
    }),
    children: /*#__PURE__*/_jsx(UsersList, {
      ownerId: ownerId,
      selectedTeams: selectedTeams,
      selectedUsers: selectedUsers,
      teams: teams,
      usersForTeams: usersForTeams,
      userSearch: userSearch,
      handleUserChange: handleUserChange,
      handleUserSearch: handleUserSearch,
      canAssignContent: canAssignContent
    })
  })]
});
export default AssignmentPanelTabs;